/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';
import { KTSVG, toAbsoluteUrl } from '../../utils';
import { useLayout } from '../../layout/core';
import { DefaultTitle } from './page-title/DefaultTitle';
import { TopBar } from './TopBar';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { AccountSelector } from './page-title/AccountSelector';
import { IAuthState } from '../../redux/AuthRedux';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';

export function HeaderWrapper(): JSX.Element {
	const { config, classes, attributes } = useLayout();
	const { aside } = config;
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);

	return (
		<div
			id="kt_header"
			className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
			{...attributes.headerMenu}
		>
			<div
				className={clsx(
					classes.headerContainer.join(' '),
					'd-flex align-items-stretch justify-content-between'
				)}
			>
				{/* begin::Aside mobile toggle */}
				{aside.display && (
					<div className="d-flex align-items-center d-lg-none" title="Show aside menu">
						<div
							className="btn btn-icon btn-active-light-primary w-30px h-30px h-md-40px"
							id="kt_aside_mobile_toggle"
						>
							<KTSVG path="/media/icons/menu.svg" className="svg-icon-2x mt-1"/>
						</div>
					</div>
				)}
				{/* end::Aside mobile toggle */}
				{/* begin::Logo */}
				{!aside.display && (
					<div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
						<Link to="/dashboard" className="d-lg-none">
							<img alt="Logo" src={toAbsoluteUrl('/media/flex-logo-small.svg')} className="h-30px"/>
						</Link>
					</div>
				)}
				{/* end::Logo */}

				{aside.display && (
					<div className="d-flex align-items-center justify-content-center flex-grow-1 flex-lg-grow-0">
						<Link to="/" className="d-lg-none">
							<img alt="Logo" src={toAbsoluteUrl('/media/flex-logo-letter.jpg')} className="h-35px"/>
						</Link>
					</div>
				)}

				<div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
					<div className="d-flex align-items-center" id="kt_header_nav">
						<DefaultTitle/>
					</div>
					<div className="d-flex align-items-center">
						{
							checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN) && (
								<div className="me-4 d-none d-lg-block">
									{/*<MainMerchantFilter/>*/}
									<AccountSelector/>
								</div>
							)
						}
						<div className="d-flex align-items-stretch flex-shrink-0">
							<TopBar/>
						</div>
					</div>

				</div>
			</div>
		</div>
	);
}
